const ZoomControl = ({
	handleZoomOut,
	currentZoomIndex,
	zoomLevels,
	handleZoomIn,
	showLabel = true,
	orientation = "horizontal",
}) => {
	const isVertical = orientation === "vertical"

	return (
		<div
			className={`flex items-center bg-gray-100 rounded-lg shadow-sm ${
				isVertical
					? "flex-col px-1 py-1 space-y-2"
					: "px-1 sm:px-2 py-0.5 sm:py-1 space-x-1 sm:space-x-2"
			}`}
		>
			{/* Horizontal modda: Zoom Out (uzaklaştırma) solda */}
			{!isVertical && (
				<button
					onClick={handleZoomOut}
					disabled={currentZoomIndex === zoomLevels.length - 1}
					className={`text-gray-700 p-1 rounded-md transition-colors ${
						currentZoomIndex === zoomLevels.length - 1
							? "bg-gray-100 opacity-50 cursor-not-allowed"
							: "bg-gray-200 hover:bg-gray-300"
					}`}
					title="Uzaklaştır"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						className="h-5 w-5"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM8 10h4"
						/>
					</svg>
				</button>
			)}

			{/* Vertical modda: Zoom In (yakınlaştırma) üstte */}
			{isVertical && (
				<button
					onClick={handleZoomIn}
					disabled={currentZoomIndex === 0}
					className={`text-gray-700 p-1 rounded-md transition-colors ${
						currentZoomIndex === 0
							? "bg-gray-100 opacity-50 cursor-not-allowed"
							: "bg-gray-200 hover:bg-gray-300"
					}`}
					title="Yakınlaştır"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						className="h-5 w-5"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
						/>
					</svg>
				</button>
			)}

			{showLabel && (
				<div
					className={`flex items-center justify-center ${
						isVertical
							? "flex-col-reverse gap-[1px]"
							: "flex-row gap-[1px]"
					}`}
				>
					{[...Array(zoomLevels.length - 1)].map((_, i) => (
						<div
							key={i}
							className={`w-2.5 h-2.5 ${
								i < (zoomLevels.length - 1) - currentZoomIndex
									? "bg-black"
									: "bg-gray-200"
							}`}
						/>
					))}
				</div>
			)}

			{/* Horizontal modda: Zoom In (yakınlaştırma) sağda */}
			{!isVertical && (
				<button
					onClick={handleZoomIn}
					disabled={currentZoomIndex === 0}
					className={`text-gray-700 p-1 rounded-md transition-colors ${
						currentZoomIndex === 0
							? "bg-gray-100 opacity-50 cursor-not-allowed"
							: "bg-gray-200 hover:bg-gray-300"
					}`}
					title="Yakınlaştır"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						className="h-5 w-5"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
						/>
					</svg>
				</button>
			)}

			{/* Vertical modda: Zoom Out (uzaklaştırma) altta */}
			{isVertical && (
				<button
					onClick={handleZoomOut}
					disabled={currentZoomIndex === zoomLevels.length - 1}
					className={`text-gray-700 p-1 rounded-md transition-colors ${
						currentZoomIndex === zoomLevels.length - 1
							? "bg-gray-100 opacity-50 cursor-not-allowed"
							: "bg-gray-200 hover:bg-gray-300"
					}`}
					title="Uzaklaştır"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						className="h-5 w-5"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM8 10h4"
						/>
					</svg>
				</button>
			)}
		</div>
	)
}

export default ZoomControl
